import React, { Component } from "react";
import Pagination from "../Pagination/Pagination";
import Filter from "../Filter/Filter";
import withRouter from "../withRouter/withRouter";

import "./Coupons.css";

class Coupons extends Component {
    constructor(props) {
        super(props);
        this.request_data = this.request_data.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
        this.delete_coupon = this.delete_coupon.bind(this);
        this.toggle_active = this.toggle_active.bind(this);
        this.delete_coupon = this.delete_coupon.bind(this);
    }

    componentDidMount() {
        this.request_data();
    }

    componentDidUpdate(prevProps, prevState) {
        let { page, count, filters } = this.state;

        if (
            prevState.page !== page ||
            prevState.count !== count ||
            prevState.filters !== filters
        ) {
            this.request_data();
        }
    }

    on_page_change(page) {
        this.setState({ page });
    }

    request_data() {
        let { toast, connection } = this.props;
        let { filters, page, count } = this.state;
        connection
            .get_filtered_data("coupons", filters, null, count, null, page)
            .then((res) => {
                let { coupons, total, page } = res.data;

                this.setState({ coupons, total, page });
            })
            .catch((err) => {
                toast(
                    "خطا در دریافت کد های تخفیف",
                    " خطای : " + err,
                    " danger"
                );
            });
    }

    onFilterChange(filters) {
        filters.search == "" && delete filters.search;

        (filters.notPrinted && (filters.printed = false)) ||
            (true && delete filters.notPrinted);

        this.setState({ filters });
    }

    toggle_active(code) {
        this.props.connection
            .toggle_coupon_active(code)
            .then((res) => {
                let { code, active } = res.data;
                let { coupons } = this.state;
                let coupon = coupons.find((c) => {
                    return c.code == code;
                });
                coupon.active = active;
                this.setState({ coupons });
            })
            .catch((err) => {
                this.props.toast(
                    "تغیر حالت",
                    "خطا در تغیر حالت کد تخفیف",
                    " danger"
                );
            });
    }

    delete_coupon(code) {
        this.props.connection
            .delete_coupon(code)
            .then((res) => {
                let { coupons } = this.state;
                coupons.splice(
                    coupons.findIndex((c) => {
                        return c.code == code;
                    }),
                    1
                );
                this.setState({ coupons });
            })
            .catch((err) => {
                this.props.toast(
                    "حذف کد تخفیف",
                    "خطا در حذف کد تخفیف",
                    " danger"
                );
            });
    }
    state = {
        coupons: null,
        count: 10,
        page: 0,
        filters: null,
        total: null,
    };
    render() {
        let { coupons, count, total, page } = this.state;

        return (
            <div className="CouponsComponent">
                <Filter
                    filters={[
                        { label: "غیر فعال", value: "notActive" },
                        { label: "فعال", value: "active" },
                        { label: "منقضی شده", value: "expired" },
                        { label: "تمام شده", value: "usedOut" },
                    ]}
                    onFilterChange={this.onFilterChange}
                />
                <a href="/coupon/new" className="add_coupon btn info">
                    اضافه کردن کد تخفیف
                </a>
                <div className="coupons">
                    <div className="list">
                        {coupons && coupons.length > 0 ? (
                            coupons.map((coupon) => {
                                console.log(
                                    coupon.expire,
                                    coupon.expire < Date.now()
                                );
                                return (
                                    <div className="coupon" key={coupon.code}>
                                        <a
                                            href={"/coupon/code/" + coupon.code}
                                            className="code text primary"
                                        >
                                            {coupon.code}
                                        </a>
                                        <div className="active">
                                            {coupon.expire &&
                                            coupon.expire < Date.now() ? (
                                                <i className="fa-solid fa-calendar-xmark text warning"></i>
                                            ) : coupon.active ? (
                                                <i className="fa-regular fa-circle-check text confirm"></i>
                                            ) : (
                                                <i className="fa-regular fa-circle-xmark text danger"></i>
                                            )}
                                        </div>
                                        <div className={"expire text danger"}>
                                            {coupon.expire
                                                ? new Date(
                                                      coupon.expire
                                                  ).toLocaleString("fa-IR")
                                                : "بدون انقضا"}
                                        </div>
                                        <div className="limit">
                                            {`${coupon.used_count}${
                                                coupon.limit
                                                    ? `   از  ${coupon.limit}  `
                                                    : ""
                                            }  استفاده شده `}
                                        </div>
                                        <div className="actions">
                                            <button
                                                className="active"
                                                onClick={(ev) => {
                                                    this.toggle_active(
                                                        coupon.code
                                                    );
                                                }}
                                            >
                                                {coupon.active ? (
                                                    <i className="fa-regular fa-circle-xmark btn warning"></i>
                                                ) : (
                                                    <i className="fa-regular fa-circle-check btn confirm"></i>
                                                )}
                                            </button>
                                            <button
                                                className="delete"
                                                onClick={(ev) =>
                                                    this.delete_coupon(
                                                        coupon.code
                                                    )
                                                }
                                            >
                                                <i className="ri-delete-bin-5-line btn danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no_coupons">کوپنی وجود ندارد</div>
                        )}
                    </div>
                    {total && page !== null && count ? (
                        <Pagination
                            count={count}
                            page={page}
                            total={total}
                            on_page_change={(p) => this.on_page_change(p)}
                        />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Coupons);
